import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-630626f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sidenav"
}
const _hoisted_2 = { class: "sidenav-header" }
const _hoisted_3 = { class: "user-info" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "user-logo-placeholder"
}
const _hoisted_6 = { class: "user-text" }
const _hoisted_7 = { class: "company-name" }
const _hoisted_8 = { class: "user-name" }
const _hoisted_9 = { class: "sidenav-footer" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<span class=\"sidenav-icon\" data-v-630626f8><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-630626f8><path d=\"M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4\" data-v-630626f8></path><polyline points=\"16 17 21 12 16 7\" data-v-630626f8></polyline><line x1=\"21\" y1=\"12\" x2=\"9\" y2=\"12\" data-v-630626f8></line></svg></span><span class=\"sidenav-text\" data-v-630626f8>로그아웃</span>", 2)
const _hoisted_12 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidenavList = _resolveComponent("SidenavList")!

  return (_ctx.showSidenav)
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.companyImageUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.companyImageUrl,
                  class: "user-logo",
                  alt: "company logo"
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.companyName ? _ctx.companyName.charAt(0) : 'R'), 1)
                ])),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.companyName), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.userName), 1)
            ])
          ])
        ]),
        _createVNode(_component_SidenavList),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "sidenav-item",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
          }, _hoisted_12)
        ])
      ]))
    : _createCommentVNode("", true)
}